import React from 'react';
import type { WorkflowRenderCatalog } from './types';
import { WorkflowRenderCatalogContext } from './index';

export const WorkflowRenderCatalogProvider: React.FC<{
  catalog: WorkflowRenderCatalog;
  children: React.ReactNode;
}> = ({ catalog, children }) => (
  <WorkflowRenderCatalogContext.Provider value={catalog}>
    {children}
  </WorkflowRenderCatalogContext.Provider>
);
